/*
 * Copyright © 2023 Broadcom. All rights reserved. The term “Broadcom” refers to Broadcom Inc. and/or its subsidiaries. All trademarks, trade names, service marks, and logos referenced herein belong to their respective companies.
 * This software and all information contained therein is confidential and proprietary and shall not be duplicated, used, disclosed or disseminated in any way except as authorized by the applicable license agreement, without the express written permission of Broadcom. All authorized reproductions must be marked with this language.
 * EXCEPT AS SET FORTH IN THE APPLICABLE LICENSE AGREEMENT, TO THE EXTENT PERMITTED BY APPLICABLE LAW OR AS AGREED BY BROADCOM IN ITS APPLICABLE LICENSE AGREEMENT, BROADCOM PROVIDES THIS DOCUMENTATION “AS IS” WITHOUT WARRANTY OF ANY KIND, INCLUDING WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NONINFRINGEMENT. IN NO EVENT WILL BROADCOM BE LIABLE TO THE END USER OR ANY THIRD PARTY FOR ANY LOSS OR DAMAGE, DIRECT OR INDIRECT, FROM THE USE OF THIS DOCUMENTATION, INCLUDING WITHOUT LIMITATION, LOST PROFITS, LOST INVESTMENT, BUSINESS INTERRUPTION, GOODWILL, OR LOST DATA, EVEN IF BROADCOM IS EXPRESSLY ADVISED IN ADVANCE OF THE POSSIBILITY OF SUCH LOSS OR DAMAGE.
 */
import React from "react";
import PropTypes from "prop-types";
import { Link, Route } from "react-router-dom";
import { ShowMoreIcon } from "../ui-components/uim-components";
import Resource from "./Resource";
// import { Link } from '@mineral/core';

//Homestub
const HomeStub = Resource.get("Home");

//Dashboards
const Dashboards = "Dashboard Viewer"; // Resource.get("Dashboards");

//Monitoring Configuring Service
const MonitoringConfiguringService = Resource.get(
  "Monitoring Configuring Service"
);

const Breadcrumb = (props) => {
  const { item, isFirstCrumb, isFinalCrumb } = props;
  const onClick = () => {
    props.resetCardPage();
    props.handleClick(props.item);
  };
  if (!item) {
    return null;
  }
  const crumbPath = Object.values(item)[1];
  const mcsBreadcrumb =
    crumbPath === "/technologies" &&
    window.location.pathname === "/operatorconsole_portlet/mcsDeploymentStatus";
  return !mcsBreadcrumb ? (
    <span className="breadcrumb">
      <Route
        path="/"
        render={({ location }) => {
          return !isFinalCrumb ? (
            <Link
              to={item.link} role="navigation"
              className={isFirstCrumb ? "breadcrumb__nolink" : "breadcrumb__link"}
              title={item.name}
              tabIndex={isFirstCrumb ? -1: 0}
              onKeyPress={(e) => {
                if (e.charCode === 13) {
                  onClick();
                }
              }} aria-label={item.name}
              onClick={(e) => {
                window.dispatchEvent(
                  new CustomEvent("updateNavLinks", { detail: item.link })
                );
                onClick();
              }}
            >
              {item.name}
              {!isFinalCrumb ? (
                <ShowMoreIcon className="breadcrumb_separator" role="img" alt="Separator" aria-label={"Separator"} />
              ) : null}
            </Link>
          ) : (
            <h1 className="breadcrumb__link" role="navigation" aria-label={item.name}>{item.name}</h1>
          );
        }}
      />
    </span>
  ) : (
    <>
      <span className="breadcrumb">
        <Link
          to="/technologies" aria-label={`${Dashboards}`}
          className="breadcrumb__link" role="navigation"
          title={`${Dashboards}`}
          onClick={(e) => {
            window.dispatchEvent(
              new CustomEvent("updateNavLinks", { detail: "/technologies" })
            );
            onClick();
          }}
        >
          {` ${Dashboards}`}
          <ShowMoreIcon className="breadcrumb_separator" role="img" alt="Separator" aria-label={"Separator"} />
        </Link>
      </span>
      <span className="breadcrumb">
        <h1 className="breadcrumb__link" role="navigation" aria-label={MonitoringConfiguringService}>{MonitoringConfiguringService}</h1>
      </span>
    </>
  );
};

Breadcrumb.defaultProps = {
  isFinalCrumb: false,
};

Breadcrumb.propTypes = {
  isFinalCrumb: PropTypes.bool,
  handleClick: PropTypes.func,
};

export default Breadcrumb;
